import {RouterItem, PathParams} from '../interface';
export const routerPublicPath = process.env.REACT_APP_ROUTER_PUBLIC_PATH || '';

const routers = {
    Home: {
        name: 'home',
        path: routerPublicPath + '/',
    },
    FindPage: {
        name: 'findPage',
        path: routerPublicPath + '/discovery/:tab?',
    },
    FindPageOld: {
        name: 'findPage',
        path: routerPublicPath + '/findPage/:tab?',
    },
    PersonalHome: {
        name: 'personalHome',
        path: routerPublicPath + '/home/:userName',
        knowledgeStarHelp: routerPublicPath + '/home/static/knowledgeStarHelp',
        recentDynamic: routerPublicPath + '/home/:userName/recentDynamic',
        exchangeEasyCoin: routerPublicPath + '/home/:userName/exchangeEasyCoin',
        inviteActive: routerPublicPath + '/home/inviteActive',
        wikiAdmin: routerPublicPath + '/home/wiki_admin',
    },
    Knowledge: {
        name: 'knowledge',
        path: routerPublicPath + '/knowledge/:spaceGuid/:groupGuid/:repositoryGuid/:docGuid?',
        docPath: routerPublicPath + '/knowledge/:spaceGuid/:groupGuid/:repositoryGuid/:docGuid',
        // 版本预览页
        docEditionPath: routerPublicPath + '/knowledge/:spaceGuid/:groupGuid/:repositoryGuid/:docGuid/edition',
        personalPath: routerPublicPath + '/user/:userGuid',
        membersPath: routerPublicPath + '/knowledge/:spaceGuid/:groupGuid/:repositoryGuid/members',
        settingPath: routerPublicPath + '/knowledge/:spaceGuid/:groupGuid/:repositoryGuid/setting/:tab',
        recycleBinPath: routerPublicPath + '/knowledge/:spaceGuid/:groupGuid/:repositoryGuid/recycleBin',
        homeTagPath: routerPublicPath + '/knowledge/:spaceGuid/:groupGuid/:repositoryGuid/homeTag/:tagName?',
        helpPath: routerPublicPath + '/knowledge/:spaceGuid/:groupGuid/munIPCvcFy/',
        repositoryIntroDetail: routerPublicPath + '/knowledge/:spaceGuid/:groupGuid/:repositoryGuid/intro',
        repositoryPath: routerPublicPath + '/knowledge/:spaceGuid/:groupGuid/:repositoryGuid',
        mobilePath: routerPublicPath + '/m/knowledge/:spaceGuid?/:groupGuid?/:repositoryGuid?/:docGuid?',
        mobileDocPath: routerPublicPath + '/m/knowledge/:spaceGuid/:groupGuid/:repositoryGuid/:docGuid',
        mobilePersonalPath: routerPublicPath + '/m/user/:userGuid',
        kuShareError: routerPublicPath + '/knowledge/kuShareError',
        // 广场推荐文章落地页
        squareDocRootPath: routerPublicPath + '/knowledge/:spaceGuid/:groupGuid/:repositoryGuid/square',
        squareDocPath: routerPublicPath + '/knowledge/:spaceGuid/:groupGuid/:repositoryGuid/square/:docGuid?',
        // 知识库智能问答
        QACenterPath: routerPublicPath + '/knowledge/:spaceGuid/:groupGuid/:repositoryGuid/QACenter',
    },
    Department: {
        name: 'department',
        path: routerPublicPath + '/department/:spaceGuid/:groupGuid/:tab?',
        departmentWeekReport: routerPublicPath + '/department/:spaceGuid/:groupGuid/weekReport',
        departmentNoticeList: routerPublicPath + '/department/:spaceGuid/:groupGuid/noticeList',
        departmentNoticeAdd: routerPublicPath + '/department/:spaceGuid/:groupGuid/notice/:repositoryGuid/:docGuid',
        departmentMessage: routerPublicPath + '/department/:spaceGuid/:groupGuid/message',
        departmentIntroDetail: routerPublicPath + '/department/:spaceGuid/:groupGuid/intro',
        departmentSettings: routerPublicPath + '/department/:spaceGuid/:groupGuid/setting',
        departmentRecycleBin: routerPublicPath + '/department/:spaceGuid/:groupGuid/departmentRecycleBin',
        departmentPowerRecycle: routerPublicPath + '/department/:spaceGuid/:groupGuid/powerRecycle',
        departmentApplivalList: routerPublicPath + '/department/:spaceGuid/:groupGuid/setting/approvalList',
        departmentSecuritySettings: routerPublicPath + '/department/:spaceGuid/:groupGuid/setting/securitySettings',
        departmentOperationLog: routerPublicPath + '/department/:spaceGuid/:groupGuid/setting/operationLog',
        departmentManage: routerPublicPath + '/department/manage',
        departmentPowerRecycleDetail: routerPublicPath + '/department/:spaceGuid/:groupGuid/powerRecycleDetail/:dataId',
        departmentMobilePath: routerPublicPath + '/m/department',
        departmentMobileIndex: routerPublicPath + '/m/department/:spaceGuid/:groupGuid',
        departmentMobileNoticeDetail: routerPublicPath + '/m/department/:spaceGuid/:groupGuid/notice',
        departmentMobileIntroDetail: routerPublicPath + '/m/department/:spaceGuid/:groupGuid/intro',
        departmentMobileHotKBListDetail: routerPublicPath + '/m/department/:spaceGuid/:groupGuid/hotKb',
        departmentMobileOutKBListDetail: routerPublicPath + '/m/department/:spaceGuid/:groupGuid/outKb',
        departmentMobileMessageDetail: routerPublicPath + '/m/department/:spaceGuid/:groupGuid/message',
        departmentAdminList: routerPublicPath + '/m/department/:spaceGuid/:groupGuid/adminList',
        departmentMobileApprovalSuccess: routerPublicPath + '/m/department/approvalSuccess',
    },
    baike: {
        index: routerPublicPath + '/baike',
        entity: routerPublicPath + '/baike/:name',
        homeTagPath: routerPublicPath + '/baike/homeTag/:tagName?',
        contribute: routerPublicPath + '/baike/contribute',
        brandHome: routerPublicPath + '/baike/brandHome',
    },
    aikm: {
        path: routerPublicPath + '/aikm',
    },
    redirect: {
        name: 'Redirect',
        path: routerPublicPath + '/fe-redirect/:name',
    },
    Test: {
        name: 'test',
        path: routerPublicPath + '/test/:type',
    },
    RuLiu: {
        name: 'RuLiu',
        path: 'baidu://message/?id=:ruLiuId',
    },
    RuLiuGroup: { // 打开如流群聊名片
        name: 'RuLiuGroup',
        path: 'baidu://viewobject/?type=group&id=:RuLiuGroupId',
    },
    RuLiuGroupDetail: { // 打开如流群聊会话
        name: 'RuLiuGroupDetail',
        path: 'baidu://message/?gid=:RuLiuGroupId',
    },
    OrgTree: {
        name: 'orgTree',
        // eslint-disable-next-line max-len
        path: 'https://orgtree.baidu-int.com/orgtree/r#/?isInService=true&reportQueryType=uuapName&searchPerId=:uuapName',
    },
    NotFound: {
        name: 'notFound',
        path: routerPublicPath + '/404',
        mobilePath: routerPublicPath + '/m/404',
    },
    Error: {
        name: 'error',
        path: routerPublicPath + '/500',
        mobilePath: routerPublicPath + '/m/500',
    },
    Forbidden: {
        name: 'forbidden',
        path: routerPublicPath + '/401',
        mobilePath: routerPublicPath + '/m/401',
    },
    HiddenRepo: {
        name: 'hiddenRepo',
        path: routerPublicPath + '/hidden/:repositoryGuid',
        mobilePath: routerPublicPath + '/m/hidden/:repositoryGuid',
    },
    ClientImport: { // 客户端气泡导入（后续会下掉）
        name: 'clientImport',
        path: routerPublicPath + '/client-import',
    },
    ClientTransform: { // 客户端文件转换为在线文档
        name: 'clientTransform',
        path: routerPublicPath + '/client-transform',
    },
    TemplateCreate: { // 通过模板创建页面
        name: 'templateCreate',
        path: routerPublicPath + '/template-create',
    },
    Maintain: {
        name: 'maintain',
        path: routerPublicPath + '/maintain',
    },
    searchPage: {
        name: 'search',
        path: routerPublicPath + '/search',
    },
};

export const tocRouters = {
    Login: {
        name: 'login',
        path: routerPublicPath + '/login',
    },
    Welcome: {
        name: 'home',
        path: routerPublicPath + '/',
    },
    Knowledge: {
        name: 'knowledge',
        path: routers.Knowledge.path,
        docPath: routers.Knowledge.docPath,
        repositoryPath: routers.Knowledge.repositoryPath,
    },
    Error: {
        name: 'error',
        notFound: routers.NotFound.path,
        serverError: routers.Error.path,
        // forbidden: routers.Forbidden.path,
    },
    Unauthorized: {
        name: 'unauthorized',
        path: '/403',
    },
};

const asServer = process.env.REACT_APP_AS_SERVER || window.location.origin;
export const kuHost = asServer.replace('/wiki', '');
const rteServer = process.env.REACT_APP_RTE_SERVER || '';
const kuShareServer = process.env.REACT_APP_KU_SHARE_SERVER || '';
const kuShareWsServer = process.env.REACT_APP_KU_SHARE_WS_SERVER || `${kuShareServer}/kuShare/ws`;
const protocol = window.location.protocol;
const wsProtocol = protocol === 'https:' ? 'wss:' : 'ws:';
export const ServerConfig = {
    origin: `${protocol}//${asServer.replace('/wiki', '')}`,
    kuWsOrigin: `${wsProtocol}//${kuHost}`,
    wiki: `${protocol}//${asServer}`,
    as: `${protocol}//${asServer}/as`,
    ks: `${protocol}//${asServer}/ks`,
    ku: `${protocol}//${asServer}/ku`,
    rte: `${protocol}//${rteServer}`,
    kuShare: `${protocol}//${kuShareServer}/kuShare`,
    kuShareWs: `${wsProtocol}//${kuShareWsServer}`,
    baikeUpload: `${protocol}//${asServer}`,
    attach: `${protocol}//${asServer}/attach`,
    toc: `${protocol}//${asServer}/ku/pass`, // toc新增接口，仅外网使用
};

export const rteHost = rteServer;

export function buildPath(pathTemplate: RouterItem | string, params: PathParams) {
    const keys = Object.keys(params);
    let path = '';
    if (typeof pathTemplate === 'string') {
        path = pathTemplate;
    } else {
        path = pathTemplate.path;
    }
    keys.forEach(key => {
        const reg = new RegExp(`:${key}\\??`, 'g');
        const value = params[key];
        path = path.replace(reg, value);
    });
    return path;
}

export default routers;
